import { useQuery } from 'react-query';

import { GetManyResult } from 'core/types';
import { customerExternalNumberService } from 'customer/services';
import { ICustomerExternalNumber, ICustomerExternalNumberPayload } from 'customer/types';

export const useGetExternalCustomerNumbers = (
  requestPayload?: ICustomerExternalNumberPayload,
  enabled = true
): GetManyResult<ICustomerExternalNumber> => {
  const { data, isLoading, isError } = useQuery(
    ['externalCustomerNumbers', requestPayload],
    () => customerExternalNumberService.getExternalCustomerNumbers(requestPayload),
    {
      keepPreviousData: true,
      enabled,
    }
  );

  return {
    records: data?.records ?? [],
    isLoading,
    isError,
  };
};
